import Dropdown from 'antd/lib/dropdown';
import Menu from 'antd/lib/menu';
import * as React from 'react';
import { runwayColors } from './styles/globalStyles';
import { AllApprovalsSortTypes, ApprovalsSortType } from '../types/sorts';
import { displayTextForApprovalsSortType } from '../helpers/displayHelpers';
import { updateApprovalsSort } from '../actions/sorts';
import { useDispatch, useSelector } from 'react-redux';
import { selectApprovalsSort } from '../selectors/selectors';
import { RootState } from '../reducers/reducers';
import { SignalFilled, OrderedListOutlined } from '@ant-design/icons';
import Button from 'antd/lib/button';

const ApprovalsSortComponent: React.FC = () => {
    const dispatch = useDispatch();

    const onSelectSort = (info) => {
        const sortType = info.key;
        dispatch(updateApprovalsSort({ sortType }));
    };

    const currentlySelectedSort = useSelector((state: RootState) => selectApprovalsSort(state));

    const overlayMenu = () => {
        return (
            <Menu onClick={onSelectSort} activeKey={currentlySelectedSort}>
                {AllApprovalsSortTypes.map((sortType) => (
                    <Menu.Item key={sortType} icon={iconForApprovalsSortType(sortType)}>
                        {displayTextForApprovalsSortType(sortType)}
                    </Menu.Item>
                ))}
            </Menu>
        );
    };

    return (
        <Dropdown overlay={overlayMenu} trigger={['click']}>
            <Button icon={iconForApprovalsSortType(currentlySelectedSort)}>
                Sort: {displayTextForApprovalsSortType(currentlySelectedSort)}
            </Button>
        </Dropdown>
    );
};

export default ApprovalsSortComponent;

const iconForApprovalsSortType: (sortType: ApprovalsSortType) => React.ReactNode = (sortType) => {
    const iconStyle: React.CSSProperties = { color: runwayColors.primary };
    switch (sortType) {
        case ApprovalsSortType.ItemStatus:
            return <SignalFilled style={iconStyle} />;
        case ApprovalsSortType.Default:
            return <OrderedListOutlined style={iconStyle} />;
    }
};
